import { GameModes, PhaseOfPlay, PlayPositions, PlaySessionTypes } from "../../enums";
import { enumCodec, mixed, optional, required, t } from "../../validation/validator";

export const CreatePlaySessionRequestSchema = mixed([
  required({
    account_id: t.union([t.number, t.null]),
    session_type: enumCodec(PlaySessionTypes),
    game_mode: enumCodec(GameModes),
  }),
  optional({
    play_position: enumCodec(PlayPositions),
    private_session_config: optional({
      play_list_id: t.string,
    }),
    practise_session_config: optional({
      scenario_ids: t.array(t.string),
      scenario_count: t.number,
      rating: t.number,
      game_speed: t.number,
      play_positions: t.union([t.array(enumCodec(PlayPositions)), t.null]),
      phases_of_play: t.union([t.array(enumCodec(PhaseOfPlay)), t.null]),
      awareness_tests: t.boolean,
      bullet_time_decisions: t.boolean,
    }),
    match_play_session_config: optional({}),
    progression_session_config: optional({
      game_speed: t.number,
      play_positions: t.union([t.array(enumCodec(PlayPositions)), t.null]),
      phases_of_play: t.union([t.array(enumCodec(PhaseOfPlay)), t.null]),
      awareness_tests: t.boolean,
      bullet_time_decisions: t.boolean,
    }),
    admin_config: optional({
      scenarios: t.array(t.string),
      rating_override: t.number,
      level_override: t.number,
      speed_override: t.number,
      clear_user_progression: t.boolean,
    }),
  }),
]);

export const CreatePlaySessionResponseSchema = required({
  play_session_id: t.number,
  session_type: enumCodec(PlaySessionTypes),
  game_mode: enumCodec(GameModes),
  session_targets: t.record(t.string, t.unknown),
  // Unity's legacy configuration includes mode-specific fields as well as the cognitive result record.
  play_items: t.array(t.any),
});

export const GetSessionResultsRequestSchema = mixed([required({ play_session_id: t.number }), optional({ resolve_previous_session: t.boolean })]);

export type CreatePlaySessionRequest = t.TypeOf<typeof CreatePlaySessionRequestSchema>;
export type CreatePlaySessionResponse = t.TypeOf<typeof CreatePlaySessionResponseSchema>;
